<template>
    <div>
        <div is="sui-container">
            <sui-grid>
                <sui-grid-column>
                    <sui-form size="small">
                        <h2>Authorize device</h2>
                            <sui-form-field>
                              <label>Device ID</label>
                              <sui-input placeholder="deviceID" :value="deviceId" @input="updateDeviceId($event)" />
                            </sui-form-field>
                            <sui-form-field>
                              <label>Device secret key</label>
                              <sui-input placeholder="PIN" :value="deviceSecret" @input="updateDeviceSecret($event)" />
                            </sui-form-field>
                            <sui-button type="submit" @click="checkDevice($event)">Save</sui-button>
                          </sui-form>
                </sui-grid-column>
            </sui-grid>
        </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import { mapState } from 'vuex'
import api from '@/Api';

export default {
  name: 'Auth',
  data: function () {
    return {
      count: 0
    }
  },
  computed: {
    active() {
        return this.$store.state.deviceId && this.$store.state.deviceToken
    },
    ...mapState([
        'deviceId',
        'deviceSecret',
    ])  
  },
  methods: {
    updateDeviceId(newDeviceId) {
        this.$store.commit('setDeviceId', newDeviceId);
    },
    updateDeviceSecret(v) {
        this.$store.commit('setDeviceSecret', v);    
    },
    checkDevice(event) {
        event.preventDefault();
        
        api.load(this.deviceId, this.deviceSecret).then(res => {
          this.$store.commit('setApp', res.data.parameters);    
          this.$router.push({'name': 'home'});
        })

        
        
    }  
  },
  
  components: {
    //HelloWorld
  }
}
</script>
